import { Button, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	getProductUnitTypeById,
	postProductUnitType,
	updateProductUnitType,
} from "../../../../api/productUnitType";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useSkeleton } from "../../../hooks/useSkeleton";

function getEmptyProductUnitType() {
	return {
		descripcion: null,
	};
}

export default function EditProductUnitTypesPage() {
	const [productUnitType, setProductUnitType] = useState(
		getEmptyProductUnitType()
	);

	const productUnitTypeId = useParams().id;
	const history = useHistory();
	const location = useLocation();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	const handleBack = () => {
		const prevTablePage = location.state?.page;

		history.push(
			`/tipos-unidades-productos${
				prevTablePage ? "?page=" + prevTablePage : ""
			}`
		);
	};

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!productUnitTypeId) {
			disableLoadingData();
			return;
		}
		getProductUnitTypeById(productUnitTypeId, loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setProductUnitType(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage:
						"No se ha podido obtener el tipo de unidad producto.",
				});
				handleBack();
			});
	}, [productUnitTypeId, disableLoadingData, history]);

	function saveProductUnitType() {
		if (!productUnitTypeId) {
			postProductUnitType(productUnitType, loggedUser?.accessToken)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "¡Guardado!",
							customMessage:
								"Tipo de unidad de producto guardado con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage:
							"No se ha podido guardar el tipo de unidad de producto.",
					});
				});
		} else {
			updateProductUnitType(
				productUnitTypeId,
				productUnitType,
				loggedUser?.accessToken
			)
				.then((res) => {
					if (res.status === 204) {
						alertSuccess({
							title: "¡Guardado!",
							customMessage: "Cambios guardados con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "No se han podido guardar los cambios.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setProductUnitType({
			...productUnitType,
			[element]: event.target.value,
		});
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title="Tipo de unidad de producto">
						<CardHeaderToolbar>
							<Button
								onClick={() => saveProductUnitType()}
								variant="outlined"
								color="primary"
							>
								Guardar unidad
							</Button>
						</CardHeaderToolbar>
					</CardHeader>
					<CardBody>
						<TextField
							id={`descripcion`}
							label="Descripción"
							value={productUnitType.descripcion}
							onChange={handleChange("descripcion")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
					</CardBody>
				</Card>
				<Button
					onClick={handleBack}
					variant="outlined"
					style={{ marginRight: "20px" }}
				>
					Atrás
				</Button>
				<Button
					onClick={() => saveProductUnitType()}
					variant="outlined"
					color="primary"
				>
					Guardar unidad
				</Button>
			</>
		);
}
